module.exports = __webpack_public_path__ + "static/media/33 - George Harrison - Love Comes To Everyone.22b03d37.mp3";